<template>
	<v-icon v-bind="iconProps" v-text="$icon" />
</template>

<script>
import * as k4util from "@/utils/k4util";

export default {
	props: {
		device: {
			type: Object,
			required: true,
		},

		icon: {
			type: String,
			default: null,
		},

		error: Boolean,

		highlight: Boolean,
	},

	computed: {
		$icon() {
			if (this.icon) return this.icon;
			return k4util.deviceFAIcon(this.device);
		},

		iconProps() {
			let props = {
				color: "grey lighten-1",
			};
			if (this.highlight) {
				props.color = "ocean";
			}
			if (this.error) {
				props.color = "rust-red";
			}
			return props;
		},
	},
};
</script>
